// AI transparency page (IDD D-HP-SITE-031): the transparency duties of Art.\u00a050 of the AI Act (Regulation (EU)
// 2024/1689) as the company meets them, and the competent German authority. German is the authoritative version.
export const aiTransparencyPageES = {
  seo: {
    title: 'Transparencia en materia de IA | pAIoneer Labs GmbH',
    description: 'Cómo utiliza pAIoneer Labs GmbH la inteligencia artificial e informa sobre ello: asistente de IA, marcado de los contenidos generados por IA, responsabilidad editorial y persona de contacto conforme al Reglamento de Inteligencia Artificial.',
    keywords: 'transparencia en materia de IA, Reglamento de Inteligencia Artificial, AI Act, art.\u00a050, marcado, asistente de IA, pAIoneer Labs GmbH',
    url: 'https://paioneer-labs.eu/ai-transparency',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'Transparencia en materia de IA',
      url: 'https://paioneer-labs.eu/ai-transparency',
      isPartOf: {
        '@type': 'WebSite',
        name: 'pAIoneer Labs GmbH',
        url: 'https://paioneer-labs.eu'
      }
    }
  },
  hero: {
    title: 'Transparencia en materia de IA',
    subtitle: 'Cómo utiliza pAIoneer Labs GmbH la inteligencia artificial e informa sobre ello.'
  },
  sections: [
    {
      title: 'Marco jurídico',
      paragraphs: [
        'Desde el 2 de agosto de 2026 se aplican las obligaciones de transparencia del art.\u00a050 del Reglamento (UE) 2024/1689 sobre inteligencia artificial (Reglamento de Inteligencia Artificial). En Alemania, conforme a la KI-Marktüberwachungs- und Innovationsförderungsgesetz (KI-MIG, Ley alemana de vigilancia del mercado de la IA y de fomento de la innovación), la Bundesnetzagentur (Agencia Federal de Redes de Alemania) es la autoridad de vigilancia del mercado y el organismo de reclamaciones para el Reglamento de Inteligencia Artificial.',
        'Esta página describe qué sistemas de IA utiliza pAIoneer Labs GmbH y cómo informa sobre ellos. El modo en que se tratan los datos personales en este contexto se describe en la política de privacidad.'
      ]
    },
    {
      title: 'Asistente de IA en nuestra aplicación',
      paragraphs: [
        'En nuestra aplicación, un asistente de IA responde a sus preguntas. Es un sistema de IA: sus respuestas son generadas automáticamente por modelos de lenguaje y pueden ser erróneas. Compruebe la información importante antes de basar decisiones en ella.',
        'La aplicación se lo indica antes de su primera entrada y de forma permanente junto al chat (art.\u00a050, apartado 1, del Reglamento de Inteligencia Artificial). Además, cada respuesta del asistente está marcada en un formato legible por máquina como generada por IA (art.\u00a050, apartado 2, del Reglamento de Inteligencia Artificial).',
        'Los modelos de lenguaje se proporcionan a través del servicio de OpenRouter, Inc., EE. UU.'
      ]
    },
    {
      title: 'Comunicación directa con sistemas de IA',
      paragraphs: [
        'Cuando un sistema de IA de pAIoneer Labs GmbH se comunica directamente con usted, por ejemplo en un chat, se identifica como sistema de IA a más tardar en la primera interacción.'
      ]
    },
    {
      title: 'Contenidos de este sitio web',
      paragraphs: [
        'Los textos de este sitio web son – también cuando herramientas de IA prestan apoyo en su elaboración – revisados por pAIoneer Labs GmbH y publicados bajo su responsabilidad editorial (art.\u00a050, apartado 4, párrafo segundo, del Reglamento de Inteligencia Artificial).',
        'Marcamos como generados o modificados artificialmente los contenidos de imagen, audio o vídeo que hayan sido generados o modificados con IA y que representen personas, lugares o acontecimientos reales de forma engañosamente realista (art.\u00a050, apartado 4, párrafo primero, del Reglamento de Inteligencia Artificial).'
      ]
    },
    {
      title: 'Análisis con aprendizaje automático',
      paragraphs: [
        'Con su consentimiento, evaluamos las estadísticas de visitas mediante métodos de aprendizaje automático; los detalles figuran en la política de privacidad. Para ello no utilizamos ni reconocimiento de emociones ni categorización biométrica (art.\u00a050, apartado 3, del Reglamento de Inteligencia Artificial). La distinción entre personas y accesos automatizados se basa en características técnicas del dispositivo, el navegador y la conexión, no en datos biométricos.'
      ]
    },
    {
      title: 'Reclamación',
      paragraphs: [
        'Puede dirigir una reclamación por una posible infracción del Reglamento de Inteligencia Artificial a la Bundesnetzagentur, la autoridad de vigilancia del mercado y organismo de reclamaciones para el Reglamento de Inteligencia Artificial en Alemania. Esta ofrece información al respecto en bundesnetzagentur.de/ki.'
      ]
    }
  ],
  contact: {
    title: 'Contacto',
    description: 'Para consultas sobre el uso de la inteligencia artificial, puede contactarnos por correo electrónico.',
    email: 'info@paioneer.eu'
  },
  lastUpdated: 'Última actualización: 30 de octubre de 2026. Prevalece la versión alemana.'
};
